import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { Calendar } from '../features/calendar/calendar-slice';
import { api } from './api.service';
import { converToLocalTimeZone } from '../lib/dayjs';

interface IAvailableTimesRequest {
  calendarsAvailables: Calendar[];
  doctorId: string | null;
  month: string;
  year: string;
}

export interface IAppointments {
  availableList: string[];
  availableListAddress: { [key: string]: string[] }[];
}

export const availableTimes = api.injectEndpoints({
  endpoints: build => ({
    getAvailableTimes: build.mutation<IAppointments, IAvailableTimesRequest>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const { calendarsAvailables, month, year, doctorId } = _arg;

        const buildQuery = (calendar: Calendar): string => {
          return `calendars/${calendar.id}${doctorId ? `/${doctorId}` : ''}/availableTimes/${month}/${year}${
            doctorId ? `/false` : ''
          }`;
        };

        const fetchCalendar = async (calendar: Calendar) => {
          const response = await fetchWithBQ(buildQuery(calendar));
          if (response.error) return { error: response.error as FetchBaseQueryError };
          return { data: response.data as string[] };
        };

        const fetchAllCalendars = async (calendar: Calendar): Promise<IAppointments> => {
          const response = await fetchCalendar(calendar);
          if (response.error) return { availableList: [], availableListAddress: [] };
          const requestResponse: IAppointments = { availableList: [], availableListAddress: [] };
          const availableTimeConvertedToLocalTimeZone = converToLocalTimeZone(response.data as string[]);
          requestResponse.availableList.push(...availableTimeConvertedToLocalTimeZone);
          requestResponse.availableListAddress?.push({ [calendar.id]: availableTimeConvertedToLocalTimeZone });
          return requestResponse;
        };

        const allCalendars = await Promise.all(calendarsAvailables.map(fetchAllCalendars));
        const response = allCalendars.reduce(
          (acc, calendar) => {
            return {
              availableList: [...acc.availableList, ...calendar.availableList],
              availableListAddress: [...(acc.availableListAddress ?? []), ...(calendar.availableListAddress ?? [])]
            };
          },
          { availableList: [], availableListAddress: [] }
        );
        return { data: response };
      }
    })
  })
});

export const { useGetAvailableTimesMutation } = availableTimes;
